import { render, staticRenderFns } from "./BblDubowitzScoreCard.vue?vue&type=template&id=24207a66&scoped=true&"
import script from "./BblDubowitzScoreCard.vue?vue&type=script&lang=ts&"
export * from "./BblDubowitzScoreCard.vue?vue&type=script&lang=ts&"
import style0 from "./BblDubowitzScoreCard.vue?vue&type=style&index=0&id=24207a66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24207a66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VCol,VExpandTransition,VIcon,VRow,VSelect,VSimpleTable,VSpacer,VTextField,VTooltip})
